/*
 *  Copyright © Microsoft Corporation. All rights reserved.
 */

export * from './ColorIconPicker.component';
